var exports = {
  "k": "xe564cbfb--92e5e0--container",
  "n": "xe564cbfb--92e5e0--link",
};

module.exports = exports;
